module.exports = __webpack_public_path__ + "img/preliminaryDiagnosis.443e37bb.gif";